import { useEffect, useState } from "react";
import "./ProviderModal.css";
import { getUserSuccessRate } from "../../../config/LiveApi";
import { Close } from "@mui/icons-material";
import DataTable from "../../../components/common/DataTable/DataTable";

const UserModal = ({ setShowModal }) => {
  const [providerData, setProviderData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [minutes, setMinutes] = useState(60);
  const [debouncedMinutes, setDebouncedMinutes] = useState(60);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedMinutes(minutes);
    }, 2000);

    return () => {
      clearTimeout(handler);
    };
  }, [minutes]);

  const fetchData = async (min) => {
    try {
      const response = await getUserSuccessRate(min);
      if (response?.status) {
        setProviderData(response.data || []);
      }
    } catch (err) {
      console.error("Error fetching provider success rate:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData(debouncedMinutes);
  }, [debouncedMinutes]);

  const columns = [
    {
      key: "serialNo",
      header: "S.No",
      render: (_, index) => index + 1,
    },
    {
      key: "merchantName",
      header: "Merchant Name",
      wrapHeader: true,
      render: (row) => row?.alias ?? row?.id ?? "N/A",
    },
    {
      key: "totalTransactions",
      header: "Total Count",
      wrapHeader: true,
      render: (row) => row.totalTransactions || 0,
    },
    {
      key: "totalPayin",
      header: "Total Payin",
      wrapHeader: true,
      render: (row) => Number(row.totalPayin || 0).toFixed(2),
    },
    {
      key: "successCount",
      header: "Success Count",
      wrapHeader: true,
      render: (row) => (
        <span className="success-provider-success">
          {row.successCount || 0}
        </span>
      ),
    },
    {
      key: "processingCount",
      header: "Processing Count",
      wrapHeader: true,
      render: (row) => (
        <span className="processing-provider-success">
          {row.processingCount || 0}
        </span>
      ),
    },
    {
      key: "failedCount",
      header: "Failed Count",
      wrapHeader: true,
      render: (row) => (
        <span className="failed-provider-success">{row.failedCount || 0}</span>
      ),
    },
    {
      key: "successRatePercent",
      header: "Success Rate (%)",
      wrapHeader: true,
      render: (row) => `${row.successRatePercent || 0}%`,
    },
  ];

  return (
    <div className="overlay-provider-success">
      <div className="modal-provider-success">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div />
          <h3 className="title-provider-success">📊 User Success Rate</h3>
          <div className="buttons-provider-success">
            <Close
              onClick={() => setShowModal(false)}
              className="close-btn-provider-success"
            />
          </div>
        </div>
        {/* Minutes Input */}
        <div className="filter-provider-success">
          <label htmlFor="minutesInput">Enter Minutes: </label>
          <input
            id="minutesInput"
            type="number"
            value={minutes}
            min="1"
            onChange={(e) => setMinutes(Number(e.target.value))}
            className="input-provider-success"
          />
        </div>

        <div className="table-wrapper-provider-success">
          <DataTable
            columns={columns}
            data={providerData}
            loading={loading}
            emptyMessage="No User data available."
          />
        </div>
      </div>
    </div>
  );
};

export default UserModal;
